var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlockedActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13970_208044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 10.668C1.33301 8.78235 1.33301 7.83954 1.91879 7.25376C2.50458 6.66797 3.44739 6.66797 5.33301 6.66797H10.6663C12.552 6.66797 13.4948 6.66797 14.0806 7.25376C14.6663 7.83954 14.6663 8.78235 14.6663 10.668C14.6663 12.5536 14.6663 13.4964 14.0806 14.0822C13.4948 14.668 12.552 14.668 10.6663 14.668H5.33301C3.44739 14.668 2.50458 14.668 1.91879 14.0822C1.33301 13.4964 1.33301 12.5536 1.33301 10.668Z",
    stroke: "#1890FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66536V5.33203C4 3.12289 5.79086 1.33203 8 1.33203C8.5 1.33203 10.1275 1.33203 11 2.9987",
    stroke: "#1890FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33203V11.9987",
    stroke: "#1890FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13970_208044"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockedActive);
export default __webpack_public_path__ + "static/media/unlocked-active.edd38641e6030cc93c24c7833057dc95.svg";
export { ForwardRef as ReactComponent };